export default __webpack_public_path__ + "static/lozenge-dropdown-dont-1-dark-84b6a870ca3af8d6cfc851379dc761fc.png";